import constants from '../shared/constants';

const resizeTextarea = (textarea: HTMLTextAreaElement): void => {
    textarea.style.height = '';
    textarea.style.height = `${textarea.scrollHeight + 10}px`;
};

document.addEventListener('DOMContentLoaded', (): void => {
    const textareas = document.querySelectorAll<HTMLTextAreaElement>(constants.targets.formAutoResizeTextarea);

    textareas.forEach((textarea) => {
        resizeTextarea(textarea);
    });
});

document.addEventListener('input', (event: Event): void => {
    const target = event.target;

    if (!(target instanceof HTMLTextAreaElement) || !target.matches(constants.targets.formAutoResizeTextarea)) {
        return;
    }

    resizeTextarea(target);
});
